<div class="top-nav-btn-inner">
  <img [src]="partialImagePath + btnDetails.imageName" class="btn-image" />
  <p class="btn-title" [ngClass]="{ isBolded: isBolded }">
    {{ btnDetails.title }}
  </p>
</div>
